var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-override form-login"},[_c('b-alert',{attrs:{"show":"","variant":"success"}},[_vm._v(" Please wait ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }